module.exports = __webpack_public_path__ + "static/img/3_1.49eafa08.jpg";